import axios from "axios"

const prefix = "tendero-movil/creditos"

const creditos = {
    detalle: params => axios.get(`${prefix}/detalle`, { params }),
    detalleLeechero: params => axios.get(`${prefix}/detalle-leechero`, { params }),
}

export default creditos